<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps<{
    variant?: 'primary' | 'success' | 'danger' | 'warning' | 'gray' | 'info',
    size?: 'sm' | 'md' | 'lg',
  }>()

  const isPrimary = computed(() => props.variant === 'primary')
  const isSuccess = computed(() => props.variant === 'success')
  const isDanger = computed(() => props.variant === 'danger')
  const isWarning = computed(() => props.variant === 'warning')
  const isGray = computed(() => props.variant === 'gray' || !props.variant)
  const isInfo = computed(() => props.variant === 'info')

  const isSmall = computed(() => props.size === 'sm')
  const isMedium = computed(() => props.size === 'md' || !props.size)
  const isLarge = computed(() => props.size === 'lg')
</script>

<template>
  <span
    class="badge"
    :class="{
      primary: isPrimary,
      success: isSuccess,
      danger: isDanger,
      warning: isWarning,
      gray: isGray,
      info: isInfo,
      sm: isSmall,
      md: isMedium,
      lg: isLarge,
    }">
    <slot></slot>
  </span>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";
  .badge {
    @apply inline-flex items-center justify-center text-center;
    @apply px-2 py-1 text-xs font-medium;
    @apply rounded-md border-1;
  }

  .primary {
    @apply bg-primary/10 text-primary border-primary/20;
  }
  .success {
    @apply bg-success/10 text-success border-success/20;
  }
  .danger {
    @apply bg-danger/10 text-danger border-danger/20;
  }
  .warning {
    @apply bg-warning/10 text-warning border-warning/20;
  }
  .gray {
    @apply bg-gray-100 text-gray-600 border-gray-200;
  }
  .info {
    @apply bg-blue-50 text-blue-600 border-blue-200;
  }

  .sm {
    @apply text-xs px-1.5 py-0.5;
  }
  .md {
    @apply text-xs px-2 py-1;
  }
  .lg {
    @apply text-sm px-3 py-1.5;
  }
</style>
